import IconNamesType from 'presentation/icons/IconNamesType';
import {EndpointProps} from 'presentation/hooks/useGetEndpointUrl/types';
import {FeaturesEnum} from 'presentation/constants';

type ServiceList = {
	category: string;
	list: Service[];
};

type Service = {
	route?: string;
	icon: IconNamesType;
	title: string;
	endpoint?: EndpointProps;
	isInversedColor?: boolean;
	show: boolean;
	openInIframe?: boolean;
	externalLink?: string;
	featureFlag?: FeaturesEnum;
	warningDrawerContent?: boolean;
	type: ServicesTypesEnum;
	dataTagId?: string;
	id?: string;
	handleClick?: () => void;
	isBlob?: boolean;
	disableCache?: boolean;
};

enum ServicesTypesEnum {
	HEALTH = 'health',
	EXAMS = 'exams',
	ODONTO = 'odonto',
	TELEHEALTH = 'telehealth',
	EMERGENCY_TELEHEALTH = 'emergency-telehealth',
	AUTHORIZATIONS = 'authorizations',
	OTHERS = 'others',
}

export type {ServiceList, Service};

export {ServicesTypesEnum};
